module.exports = __webpack_public_path__ + "img/lock.a4f65452.svg";